module.exports = __webpack_public_path__ + "img/drone_04_H.41b683bc.webp";